/* Výpis kolekce – redesign DESIGNSPOT (10/2026)
   Filtry (rozbalovací nabídky, mobilní panel), řazení, posuvné dlaždice podkategorií,
   „Načíst další“ s obnovou pozice po návratu zpět (sessionStorage). */
(function () {
  var root = document.getElementById('DsPlp');
  if (!root) return;
  root.classList.add('js-ds');
  var sectionId = root.getAttribute('data-section-id');
  var form = root.querySelector('[data-ds-filters]');
  var mq = window.matchMedia('(max-width: 599px)');

  /* ---------- URL z formuláře ---------- */
  function formUrl() {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) {
      if (String(v).trim() !== '') params.append(k, v);
    });
    var q = params.toString();
    return form.getAttribute('action') + (q ? '?' + q : '');
  }
  function go(url) { window.location.href = url; }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      go(formUrl());
    });

    /* počítač: zaškrtnutí = hned použít; mobil: jen přepočítat počet */
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-ds-sort]')) return;
      if (!t.matches('[data-ds-auto]')) return;
      if (mq.matches) updateCount(); else go(formUrl());
    });

    /* řazení */
    var sortSel = root.querySelector('[data-ds-sort]');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        form.querySelector('input[name="sort_by"]').value = sortSel.value;
        go(formUrl());
      });
    }

    /* rozbalovací nabídky – vždy jen jedna otevřená (počítač) */
    var dds = root.querySelectorAll('[data-ds-dd]');
    dds.forEach(function (dd) {
      dd.addEventListener('toggle', function () {
        if (!dd.open || mq.matches) return;
        dds.forEach(function (o) { if (o !== dd) o.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (mq.matches) return;
      dds.forEach(function (dd) { if (dd.open && !dd.contains(e.target)) dd.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      dds.forEach(function (dd) { dd.open = false; });
      closeSheet();
    });

    /* mobilní panel */
    var sheet = root.querySelector('[data-ds-sheet]');
    function openSheet() { sheet.classList.add('is-open'); document.body.classList.add('ds-sheet-lock'); }
    function closeSheet() { if (!sheet) return; sheet.classList.remove('is-open'); document.body.classList.remove('ds-sheet-lock'); }
    root.querySelectorAll('[data-ds-sheet-open]').forEach(function (b) { b.addEventListener('click', openSheet); });
    root.querySelectorAll('[data-ds-sheet-close]').forEach(function (b) { b.addEventListener('click', closeSheet); });

    var countEl = root.querySelector('[data-ds-count]');
    var countReq = 0;
    function updateCount() {
      if (!countEl) return;
      var id = ++countReq;
      var url = formUrl();
      url += (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        if (id !== countReq) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var c = doc.querySelector('[data-ds-count]');
        if (c) countEl.textContent = c.textContent;
      }).catch(function () {});
    }
  }

  /* ---------- dlaždice podkategorií – šipky ---------- */
  var tiles = root.querySelector('[data-ds-tiles-list]');
  if (tiles) {
    var prev = root.querySelector('[data-ds-tiles-prev]');
    var next = root.querySelector('[data-ds-tiles-next]');
    function navState() {
      var max = tiles.scrollWidth - tiles.clientWidth;
      prev.hidden = tiles.scrollLeft <= 4;
      next.hidden = tiles.scrollLeft >= max - 4;
    }
    function step(dir) { tiles.scrollBy({ left: dir * tiles.clientWidth * 0.8, behavior: 'smooth' }); }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    tiles.addEventListener('scroll', navState, { passive: true });
    window.addEventListener('resize', navState);
    var active = tiles.querySelector('.is-active');
    if (active) tiles.scrollLeft = Math.max(0, active.offsetLeft - 40);
    navState();
  }

  /* ---------- Načíst další ---------- */
  var grid = root.querySelector('[data-ds-grid]');
  var more = root.querySelector('[data-ds-more]');
  var storeKey = 'dsplp:' + location.pathname + location.search;

  function bindMore() {
    var btn = more && more.querySelector('[data-ds-next]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      var href = btn.getAttribute('href');
      var url = href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-ds-grid]');
        var newMore = doc.querySelector('[data-ds-more]');
        if (newGrid) {
          var frag = document.createDocumentFragment();
          Array.prototype.slice.call(newGrid.children).forEach(function (el) {
            if (!el.classList.contains('ds-card--banner')) frag.appendChild(el);
          });
          grid.appendChild(frag);
        }
        if (newMore) { more.innerHTML = newMore.innerHTML; } else { more.remove(); more = null; }
        history.replaceState(history.state, '', href);
        storeKey = 'dsplp:' + location.pathname + location.search;
        document.dispatchEvent(new CustomEvent('ds:plp:appended'));
        bindMore();
      }).catch(function () { go(href); });
    });
  }
  bindMore();

  /* uložení stavu při odchodu ze stránky */
  window.addEventListener('pagehide', function () {
    try {
      sessionStorage.setItem(storeKey, JSON.stringify({
        grid: grid.innerHTML,
        more: more ? more.innerHTML : null,
        y: window.scrollY
      }));
    } catch (e) {}
  });

  /* obnova po návratu zpět */
  try {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var isBack = nav && nav.type === 'back_forward';
    var saved = sessionStorage.getItem(storeKey);
    if (isBack && saved) {
      var st = JSON.parse(saved);
      grid.innerHTML = st.grid;
      if (more) { if (st.more) { more.innerHTML = st.more; bindMore(); } else { more.remove(); more = null; } }
      document.dispatchEvent(new CustomEvent('ds:plp:appended'));
      requestAnimationFrame(function () { window.scrollTo(0, st.y || 0); });
    }
  } catch (e) {}
})();
